import { useQuery } from "@tanstack/react-query";
import {
  CountryCode,
  GeographicTrainMapTopology,
} from "@vygruppen/vy-train-map";
import { getTrafficguiBaseUrl } from "api/common";
import { queryFnGET } from "api/tanStackQuery/helpers";

const TOPOLOGY_QUERY_KEY = "topology";

export const useTrainMapTopology = (countryCode: CountryCode) => {
  const { data: trainMapTopology, status: trainMapTopologyStatus } = useQuery({
    queryKey: [TOPOLOGY_QUERY_KEY, countryCode],
    queryFn: ({ signal }) =>
      queryFnGET<GeographicTrainMapTopology>({
        signal,
        url: `${getTrafficguiBaseUrl()}/trainmap-backend/topology?countryCode=${countryCode}`,
      }),
  });

  return { trainMapTopology, trainMapTopologyStatus };
};
